const LogoIcon = "/logo-educacity.png";
const BavyroxLogo = "/Bavyrox.png";
const ZennexuLogo = "/zennexu logo black.png";

export { default as CheckIcon } from "../assets/icons/check";
export { default as CloseIcon } from "../assets/icons/close";
export { default as XCircleIcon } from "../assets/icons/x-circle";
export { default as CheckCircleIcon } from "../assets/icons/check-circle";
export const LogoWhite = "/logo-educacity.png";

export { LogoIcon, BavyroxLogo, ZennexuLogo }